import React from 'react';

import {NucleotideType} from 'biojs/BioConstants';

export interface InsertPartProps {
  nucleotideType: NucleotideType;
}

export default function InsertPart({nucleotideType}: InsertPartProps): JSX.Element {
  return (
    <div className="insert-part-modal">
      <div className="row">
        <div className="col col-md-12 search" />
      </div>
      <div className="row">
        <div className="col col-md-12">
          <div className="selected-sequence" />
        </div>
      </div>
      {nucleotideType === NucleotideType.DNA && (
        <label className="checkbox">
          <input type="checkbox" className="reverse-complement" />
          Use Reverse Complement
        </label>
      )}
      <div className="row">
        <div className="col col-md-12">
          <span className="warning" />
        </div>
      </div>
    </div>
  );
}
